export function clone(x: any[]): any[]{

    let y: any[] = []
    x.forEach(val => y.push(Object.assign({}, val)));

    return y


  }